import { BoxProps, Center } from "@chakra-ui/react"
import GeberitSpinner from "./Geberit/GeberitSpinner"

const Loader = (props: BoxProps) => {
  return (
    <Center {...props}>
      <GeberitSpinner />
    </Center>
  )
}

export default Loader
